﻿'use strict';

angular.module('ntmApp').factory('ChangedItemsTranslator', function () {

    var service = {};

    service.ToGroup = function (filtered, allActivities) {

        var grouppedByGroupName = filtered.groupBy('groupName');

        grouppedByGroupName.forEach(function (group) {

            group.hasSubGroup = group.items[0].category === 1;

            if (group.hasSubGroup) {

                var grouppedByLocate = group.items.groupBy('location');

                grouppedByLocate.forEach(function (groupByLocate) {
                    groupByLocate.expanded = true;
                    groupByLocate.items = groupByLocate.items.map(function (activity) {
                        attachFunctionsToActivity(activity);
                        return activity;
                    });

                    groupByLocate.revert = allActivities.filter(function (activity) {
                        return activity.location === groupByLocate.key &&
                               activity.groupName === group.key;
                    }).every(function (activity) {
                        return activity.revert;
                    });

                });

                group.items = grouppedByLocate;
                group.expanded = true;
                group.revert = allActivities.filter(function (activity) {
                    return activity.groupName === group.key;
                }).every(function (activity) {
                    return activity.revert;
                });
            } else {
                group.expanded = true;
                group.items = group.items.map(function (activity) {
                    attachFunctionsToActivity(activity);
                    return activity;
                });

                group.revert = allActivities.filter(function (activity) {
                    return activity.groupName === group.key;
                }).every(function (activity) {
                    return activity.revert;
                });
            }
        });

        return grouppedByGroupName;
    };

    function attachFunctionsToActivity(activity) {
        activity.isAssigneeChanged = function () {
            return activity.currentForecastAssigneeId !== activity.scenarioAssigneeId;
        };

        activity.isScheduleDateChanged = function () {
            
            var currentForecastScheduleDate = moment(activity.currentForecastScheduleDate);
            var scenarioScheduleDate = moment(activity.scenarioScheduleDate);
            return !currentForecastScheduleDate.isSame(scenarioScheduleDate);
        };

        activity.isStatusChanged = function () {
            return activity.currentForecastStatusId !== activity.scenarioStatusId;
        };
    }

    return service;
});